@if (firstValidIndex !== -1) {
  <div>
    <!-- show the shortened text -->
    @if (!showFullText) {
      <h2>{{ headers[firstValidIndex] | hisUi }}</h2>
      <!-- show the shortened text -->
      @if (hisObjects[firstValidIndex] && hisAttribute) {
        <div>
        @if (!hisObjects[firstValidIndex][hisAttribute].contains('</li></ul>')) {
          <his-translated-text [hisobject]="hisObjects[firstValidIndex]" [hisAttribute]="hisAttribute" [maxLength]="maxLength"/>
        }
      @if (hisObjects[firstValidIndex][hisAttribute].contains('</li></ul>')) {
        <his-translated-html [hisobject]="hisObjects[firstValidIndex]" [hisAttribute]="hisAttribute" [maxLength]="maxLength" />
      }
    </div>
  }
} @else {
  @for (header of headers; track header; let index = $index) {
    <div class="description">
      @if (isEntryValid(hisObjects[index])) {
        <h2>{{ header | hisUi }}</h2>
        <!-- show text in full length -->
        <div class="layoutBlock">
          <div class="wordBreak columnDetailLabel fullWidth">
          @if (!hisObjects[index][hisAttribute].contains('</li></ul>')) {
            <his-translated-text [hisobject]="hisObjects[index]" [hisAttribute]="hisAttribute" />
          }
        @if (hisObjects[index][hisAttribute].contains('</li></ul>')) {
          <his-translated-html [hisobject]="hisObjects[index]" [hisAttribute]="hisAttribute" />
        }
      </div>
    </div>
  }
</div>
}
}
<!-- show text in full length -->
@if (showButtons) {
  @if (!showFullText) {
    <button (click)="setShowFullText(true)" class="icon" hisImage="ARROW_DOWN_V" title="{{ expandToolTip | hisUi }}"></button>
  }
  @if (showFullText) {
    <button (click)="setShowFullText(false)" class="icon" hisImage="ARROW_UP_V" title="{{ collapseToolTip | hisUi }}"></button>
  }
}
</div>
}